import { type VariantProps, cva, cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import { type TextProps, TextStyles } from '../text';

import type { JSX } from 'react';

export interface ParagraphProps
    extends TextProps,
        VariantProps<typeof paragraphStyles> {}

const paragraphStyles = cva('mb-4');

export const Paragraph = ({
    size,
    className,
    children,
    testId = 'paragraph',
    ...props
}: ParagraphProps): JSX.Element => {
    return (
        <p
            className={twMerge(
                cx(TextStyles({ size }), paragraphStyles({ className }))
            )}
            data-testid={testId}
            {...props}
        >
            {children}
        </p>
    );
};
